<template>
    <!-- 登录 -->
    <div class="logins">
        <div class="logContent">
            <div class="tiss">更换手机号</div>
            <div class="closeBtn" @click="closedo">
                <i class="el-icon-circle-close" style="color: #fff;font-size: 30px;"></i>
            </div>
            <!-- 手机号登录 -->
            <div class="phoneLogin">
                <div class="plItem flx alc">
                    <div class="phoneInp flx alc jsb">
                        <img :src="$Localimg('phoneIcon.png')" alt="" />
                        <input type="phone" disabled max-length="11" v-model="oldphone" />
                    </div>
                </div>
                <div class="plItem flx alc jsb" style="margin-top: 20px;">
                    <div class="phoneInp flx alc jsb" style="width: 245px;">
                        <img :src="$Localimg('gurdIcon.png')" alt="" />
                        <input type="phone" placeholder="请输入短信验证码" max-length="6" v-model="oldcode" />
                    </div>
                    <div class="sendCode cursor" @click="sendCode1">
                        {{ isCountDown1 ? `${count1} 秒后重发` : '获取验证码' }}
                    </div>
                </div>
                <div class="plItem flx alc" style="margin-top: 20px;">
                    <div class="phoneInp flx alc jsb">
                        <img :src="$Localimg('phoneIcon.png')" alt="" />
                        <input type="phone" placeholder="请输入手机号码" max-length="11" v-model="newphone" />
                    </div>
                </div>
                <div class="plItem flx alc jsb" style="margin-top: 20px;">
                    <div class="phoneInp flx alc jsb" style="width: 245px;">
                        <img :src="$Localimg('gurdIcon.png')" alt="" />
                        <input type="phone" placeholder="请输入短信验证码" max-length="6" v-model="newcode" />
                    </div>
                    <div class="sendCode cursor" @click="sendCode">
                        {{ isCountDown ? `${count} 秒后重发` : '获取验证码' }}
                    </div>
                </div>
            </div>
            <!-- 登录按钮 -->
            <div class="Loginbtn cursor" @click="toLogin">
                确认
            </div>
        </div>
    </div>
</template>

<script>
    import {
        shoUserInfo,
        shopchangePhone,
        sendCode 
    } from "@/api/index.js"
    export default {
        name: 'Login',
        data() {
            return {
               oldphone: "",
               newphone:"",
               oldcode:"",
               codeTxct: "获取验证码",
               newcode: "",
               sending: false,
               hasRead: false,
               isCountDown: false, // 是否正在倒计时
               isCountDown1: false, // 是否正在倒计时
               count: 60, // 倒计时秒数
               count1: 60, // 倒计时秒数
               timer: null, // 定时器
               timer1:null,
               show: false,
               isLogin: false,
               phone:""
            }
        },
        created() {
            this.getUser()
        },
        methods: {
            hidePhone(phone) {
              if (!phone || phone.length !== 11) return phone;
              return phone.slice(0, 3) + '****' + phone.slice(7);
            },
            getUser(){
                let that = this
                shoUserInfo().then((res) => {
                    if(res.code == 1){
                        that.oldphone = that.hidePhone(res.data.tel)
                        that.phone = res.data.tel
                    }else{
                        that.$message.warning(res.msg)
                        return
                    }
                })
            },
            closedo(){
                this.$emit("cal",1)
            },
            
            // 登录
            toLogin() {
                let that = this
                let data = {}
                data.tel = that.newphone
                data.old_code = that.oldcode
                data.code = that.newcode
                shopchangePhone(data).then((res) => {
                    if(res.code == 1){
                         that.$message.success(res.msg)
                         that.closedo()
                    }else{
                        that.$message.error(res.msg)
                    }
                })
            },
            
            sendCode1() {
                let that = this
                console.log(this.phone)
                // 简单手机号校验
                if (!/^1[3-9]\d{9}$/.test(this.phone)) {
                    this.$message.warning('请输入正确的手机号')
                    return
                }
                // 模拟发送验证码接口
                console.log('发送验证码到：', this.phone)
                if (this.isCountDown1 == false) {
                    let data = {}
                    data.tel = that.phone
                    data.type = 2
                    sendCode(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            // 开始倒计时
                            this.isCountDown1 = true
                            let time = this.count1
                            this.timer1 = setInterval(() => {
                                time--
                                this.count1 = time
                                if (time <= 0) {
                                    clearInterval(this.timer1)
                                    this.isCountDown1 = false
                                    this.count1 = 60
                                }
                            }, 1000)
                            this.$message.success('验证码已发送')
                        } else {
                            that.$message.error(res.msg)
                        }
                    })
            
                }
            },

            // 发送验证码
            sendCode() {
                let that = this
                // 简单手机号校验
                if (!/^1[3-9]\d{9}$/.test(this.newphone)) {
                    this.$message.warning('请输入正确的手机号')
                    return
                }
                // 模拟发送验证码接口
                console.log('发送验证码到：', this.newphone)
                if (this.isCountDown == false) {
                    let data = {}
                    data.tel = that.newphone
                    data.type = 2
                    sendCode(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            // 开始倒计时
                            this.isCountDown = true
                            let time = this.count
                            this.timer = setInterval(() => {
                                time--
                                this.count = time
                                if (time <= 0) {
                                    clearInterval(this.timer)
                                    this.isCountDown = false
                                    this.count = 60
                                }
                            }, 1000)
                            this.$message.success('验证码已发送')
                        } else {
                            that.$message.error(res.msg)
                        }
                    })

                }
            },
        }
    }
</script>
<style scoped>
   
    .tiss{
        font-weight: 600;
        font-size: 20px;
        color: #333333;
    }
    .Loginbtn {
        margin-bottom: 20px;
        width: 100%;
        height: 48px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 24px;
        text-align: center;
        line-height: 48px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        margin-top: 96px;
    }

    .sendCode {
        width: 91px;
        height: 48px;
        background: #F6F7F9;
        border-radius: 24px;
        text-align: center;
        line-height: 48px;
        font-size: 12px;
        color: #666666;
        font-weight: 500;
    }

    .phoneInp img {
        width: 18px;
        height: 18px;
    }

    .phoneInp input {
        flex: 1;
        box-sizing: border-box;
        padding: 0 8px;
        height: 100%;
        font-size: 14px;
        border: none !important;
        outline: none !important;
        background: transparent !important;
    }

    .phoneInp {
        width: 100%;
        height: 48px;
        background: #F6F7F9;
        border-radius: 24px;
        box-sizing: border-box;
        padding: 0 20px;
    }

    .phoneLogin {
        margin-top: 50px;
    }

    .cmActive {
        font-weight: 500 !important;
        font-size: 20px !important;
        color: #007AFF !important;
    }

    .heng {
        width: 32px;
        height: 3px;
        background: #007AFF;
        border-radius: 2px;
        margin: 10px auto 0;
    }

    .changeMetohds {
        box-sizing: border-box;
        padding: 20px 0;
    }

    .cmName {
        font-weight: 500;
        font-size: 20px;
        color: #999999;
    }

    .cmItem {
        margin: 0 24px;
        cursor: pointer;
    }

    .closeBtn {
        position: absolute;
        right: -50px;
        top: 0;
        cursor: pointer;
    }

    .logMethod img {
        width: 100%;
        height: 100%;
    }

    .logMethod {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        width: 55px;
        height: 55px;
    }

    .logContent {
        width: 420px;
        height: 562px;
        background: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 20px;
        box-sizing: border-box;
        padding:50px 30px;
    }

    .logins {
        /* width: calc(100vw / 0.85);
        height: calc(100vh / 0.85); */
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 116 !important;
    }

    .el-submenu__title:hover {
        background: transparent !important;
    }

    .el-menu--popup-bottom-start {
        margin-top: 0 !important;
    }

    .el-menu--popup {
        padding: 0 !important;
    }

    .el-menu--horizontal>.el-menu-item.is-active {
        border: none !important;
    }

    .el-menu {
        background-color: transparent !important;
    }

    .pubItem {
        font-weight: 500;
        font-size: 16px;
        color: #151515;
        padding: 0 24px;
        cursor: pointer;
    }

    .el-header {
        padding: 0 !important;
    }

    .register {
        width: 83px;
        height: 115px;
        background: #007AFF;
        text-align: center;
        line-height: 115px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 115px;
        cursor: pointer;
    }

    .shu {
        width: 1px;
        height: 14px;
        background: #D9D9D9;
    }

    .pubs {
        flex: 1;
        justify-content: flex-end;
    }

    .search {
        margin-left: 259px;
    }

    .inp {
        width: 344px;
        height: 34px;
        border: 1px solid #007AFF;
    }

    .inp input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        font-weight: 500;
        font-size: 13px;
        box-sizing: border-box;
        padding: 0 10px;
    }

    .searchBtn {
        width: 86px;
        height: 34px;
        background: #007AFF;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #007AFF;
        text-align: center;
        line-height: 34px;
        font-weight: 500;
        font-size: 13px;
        color: #FFFFFF;
    }

    .hea {
        background: pink;
        height: 115px !important;
        background: #FFFFFF;
        box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.04);
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 230px !important;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 111;
        width: 100%;
    }

    .logo {
        width: 162px;
        height: 55px;

    }

    .logo img {
        width: 100%;
        height: 100%;
    }
</style>